import { Route, useLocation, Navigate, Outlet } from "react-router-dom";
import React from "react";
import { isExpired, decodeToken } from "react-jwt";
import { CHANGEPASSWORD } from "constants";

const ProtectedRoute = ({ children, check }) => {

  const token = localStorage.getItem('token');
  const id = localStorage.getItem('id');
  let resetPassword = localStorage.getItem('resetPassword');
  const location = useLocation();
  let isMyTokenExpired = true;
  let myDecodedToken = {};

  if (token) {
    myDecodedToken = decodeToken(token);
    isMyTokenExpired = isExpired(token);
    if (id == myDecodedToken.id)
      isMyTokenExpired = isExpired(token);
  }

  let childName = null;
  if (Array.isArray(children)) {
    const validChild = children.find(child => React.isValidElement(child) && child.props && child.props.name);
    if (validChild) {
      childName = validChild.props.name;
    }
  } else if (React.isValidElement(children) && children.props && children.props.name) {
    childName = children.props.name;
  }

  return (
    <>
      {((isMyTokenExpired == false) && (check == 'login')) ?
        (resetPassword == CHANGEPASSWORD.RESETPASSWORD_SET) ?
          (childName && childName == 'changePassword') ?
            children
            :
            <Navigate to="/admin/viewProfile" state={{ from: location }} replace />
          :
          <Navigate to="/dashboard" state={{ from: location, 'toastStatus': "1" }} replace />
        :
        ((check == 'logout') && (isMyTokenExpired == true)) ?
          <Navigate to="/admin/login" state={{ from: location }} replace />
          :
          (resetPassword == CHANGEPASSWORD.RESETPASSWORD_SET) ?
            (childName && childName == 'changePassword') ?
              children
              :
              <Navigate to="/admin/viewProfile" state={{ from: location }} replace />
            :
            children
      }
    </>
  )
};

export default ProtectedRoute;
